import React, { Component } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { connect } from "react-redux";

import { usersActions } from "../../_actions";
import { notify } from "../common/Toster";
import Sidebar from "../common/sidebar";

class InviteUser extends Component {
  state = {
    countryCode: "1",
    phoneNumber: "",
    firstName: "",
    lastName: "",
    errors: {},
    submitting: false,
  };

  getRequestErrorMessage = (error, fallback) => {
    const responseData = error && error.response && error.response.data;
    return (
      (responseData && responseData.error && responseData.error.responseMessage) ||
      (responseData && responseData.message) ||
      (error && error.message) ||
      fallback
    );
  };

  handleChange = (event) => {
    const { name } = event.target;
    let { value } = event.target;
    if (name === "countryCode" || name === "phoneNumber") {
      value = value.replace(/\D/g, "");
    }

    const errors = { ...this.state.errors };
    delete errors[name];
    this.setState({ [name]: value, errors });
  };

  validate = () => {
    const errors = {};
    const countryCode = this.state.countryCode.trim();
    const phoneNumber = this.state.phoneNumber.trim();
    const firstName = this.state.firstName.trim();
    const lastName = this.state.lastName.trim();

    if (!/^\d{1,4}$/.test(countryCode)) {
      errors.countryCode = "Enter a valid country code.";
    }
    if (!/^\d{10,15}$/.test(phoneNumber)) {
      errors.phoneNumber = "Enter a 10 to 15 digit mobile number.";
    }
    if (firstName.length < 2) {
      errors.firstName = "First name must be at least 2 characters.";
    }
    if (lastName.length < 2) {
      errors.lastName = "Last name must be at least 2 characters.";
    }

    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  handleSubmit = (event) => {
    event.preventDefault();
    if (!this.validate()) {
      return;
    }

    const params = {
      countryCode: this.state.countryCode.trim(),
      phoneNumber: this.state.phoneNumber.trim(),
      firstName: this.state.firstName.trim(),
      lastName: this.state.lastName.trim(),
    };

    this.setState({ submitting: true });
    this.props.dispatch(usersActions.inviteUserBySms(params))
      .then((data) => {
        if (data.statusCode !== 1) {
          const message = data.error && data.error.responseMessage
            ? data.error.responseMessage
            : "Unable to send invitation.";
          notify("error", message);
          return;
        }

        notify("success", data.responseData.message || "Invitation sent successfully.");
        this.props.history.push("/users");
      })
      .catch((error) => {
        notify("error", this.getRequestErrorMessage(error, "Unable to send invitation."));
      })
      .finally(() => this.setState({ submitting: false }));
  };

  handleCancel = () => {
    if (!this.state.submitting) {
      this.props.history.push("/users");
    }
  };

  render() {
    const { countryCode, phoneNumber, firstName, lastName, errors, submitting } = this.state;

    return (
      <>
        <Sidebar />
        <div className="body_container">
          <div className="body_inner_wrapper">
            <header className="header_content">
              <p>Invite User</p>
            </header>
            <div className="main_content">
              <Form onSubmit={this.handleSubmit} noValidate>
                <Row className="justify-content-center">
                  <Col xl="8" lg="9" md="11">
                    <div className="farm_page">
                  <Row>
                    <Col md="3">
                      <Form.Label htmlFor="countryCode">Country code</Form.Label>
                    </Col>
                    <Col md="9">
                      <Form.Control
                        id="countryCode"
                        type="text"
                        inputMode="numeric"
                        name="countryCode"
                        value={countryCode}
                        onChange={this.handleChange}
                        maxLength={4}
                        disabled={submitting}
                        isInvalid={Boolean(errors.countryCode)}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.countryCode}
                      </Form.Control.Feedback>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="3">
                      <Form.Label htmlFor="phoneNumber">Mobile number</Form.Label>
                    </Col>
                    <Col md="9">
                      <Form.Control
                        id="phoneNumber"
                        type="tel"
                        inputMode="numeric"
                        name="phoneNumber"
                        value={phoneNumber}
                        onChange={this.handleChange}
                        maxLength={15}
                        disabled={submitting}
                        isInvalid={Boolean(errors.phoneNumber)}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.phoneNumber}
                      </Form.Control.Feedback>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="3">
                      <Form.Label htmlFor="firstName">First name</Form.Label>
                    </Col>
                    <Col md="9">
                      <Form.Control
                        id="firstName"
                        type="text"
                        name="firstName"
                        value={firstName}
                        onChange={this.handleChange}
                        maxLength={50}
                        disabled={submitting}
                        isInvalid={Boolean(errors.firstName)}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.firstName}
                      </Form.Control.Feedback>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="3">
                      <Form.Label htmlFor="lastName">Last name</Form.Label>
                    </Col>
                    <Col md="9">
                      <Form.Control
                        id="lastName"
                        type="text"
                        name="lastName"
                        value={lastName}
                        onChange={this.handleChange}
                        maxLength={50}
                        disabled={submitting}
                        isInvalid={Boolean(errors.lastName)}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.lastName}
                      </Form.Control.Feedback>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="9" className="offset-md-3 text-right">
                      <Button variant="dark" onClick={this.handleCancel} disabled={submitting} className="mr-2">
                        Cancel
                      </Button>
                      <Button variant="warning" type="submit" disabled={submitting}>
                        {submitting ? "Sending..." : "Send Invitation"}
                      </Button>
                    </Col>
                  </Row>
                    </div>
                  </Col>
                </Row>
              </Form>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default connect()(InviteUser);
